// src/config/config.js
const appConfig = {
  events: {  
    event1: 'BMF_V1_0_UEC_2026_PARK', // puedes dejarlo vacío o null si aún no lo tienes
    event2: '' // puedes dejarlo vacío o null si aún no lo tienes
  }
};

export default appConfig;
